import axios from "axios";

const defaultApiBase = "http://localhost:8000";

const defaultWsBase = "ws://localhost:8000/ws";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || defaultApiBase;
const WS_BASE_URL =
  process.env.REACT_APP_WS_BASE_URL || defaultWsBase;

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
  headers: {
    Accept: "application/json",
  },
});

const axiosPrivate = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const message = error?.response?.data?.message || error.message;
    return Promise.reject(new Error(message));
  }
);

axiosPrivate.interceptors.response.use(
  (response) => response,
  (error) => {
    const message = error?.response?.data?.message || error.message;
    return Promise.reject(new Error(message));
  }
);

export { axiosPrivate, WS_BASE_URL };
export default axiosInstance;